export const categories = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '精选国内外高分电影，涵盖动作、喜剧、爱情、科幻等多种类型',
    imageQuery: 'Cinematic%20movie%20theater%20scene%20with%20warm%20golden%20lighting%2C%20film%20reel%20and%20popcorn%20on%20dark%20wooden%20surface%2C%20cozy%20atmosphere%2C%20vintage%20movie%20posters%20in%20background%2C%20artistic%20composition%2C%20rich%20amber%20and%20coral%20tones%2C%20minimal%20studio%20photography%20style',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门国产剧、韩剧、美剧一网打尽，追剧达人的不二之选',
    imageQuery: 'Modern%20living%20room%20with%20large%20TV%20screen%20displaying%20drama%20series%2C%20cozy%20sofa%20with%20throw%20blankets%2C%20warm%20ambient%20lighting%2C%20indoor%20plants%2C%20minimalist%20interior%20design%2C%20evening%20atmosphere%2C%20soft%20golden%20and%20terracotta%20tones',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '搞笑、真人秀、选秀、脱口秀，欢乐不停歇',
    imageQuery: 'Colorful%20TV%20variety%20show%20studio%20with%20bright%20stage%20lights%2C%20confetti%20floating%20in%20air%2C%20cheerful%20atmosphere%2C%20professional%20broadcast%20cameras%2C%20warm%20stage%20lighting%20with%20coral%20and%20amber%20hues%2C%20energetic%20vibe%2C%20editorial%20photography',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '热门日漫、国漫、剧场版，二次元爱好者的天堂',
    imageQuery: 'Anime%20art%20studio%20workspace%20with%20drawing%20tablet%2C%20colorful%20character%20sketches%20on%20wall%2C%20manga%20volumes%20stacked%20neatly%2C%20warm%20desk%20lamp%20lighting%2C%20creative%20atmosphere%2C%20soft%20pastel%20and%20warm%20coral%20tones%2C%20clean%20composition',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '自然、人文、历史、科技纪录片，探索世界奥秘',
    imageQuery: 'Nature%20documentary%20scene%20with%20vintage%20camera%20on%20wooden%20tripod%2C%20world%20map%20on%20wall%2C%20notebook%20and%20compass%20on%20desk%2C%20warm%20natural%20light%20streaming%20through%20window%2C%20explorer%20aesthetic%2C%20earthy%20amber%20and%20olive%20tones%2C%20editorial%20style',
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-line',
    description: 'MV、演唱会、音乐现场，让旋律触动你的心灵',
    imageQuery: 'Music%20studio%20with%20vintage%20vinyl%20record%20player%2C%20headphones%20on%20wooden%20desk%2C%20acoustic%20guitar%20leaning%20against%20wall%2C%20warm%20mood%20lighting%20with%20fairy%20lights%2C%20cozy%20creative%20space%2C%20rich%20amber%20and%20terracotta%20tones%2C%20atmospheric%20photography',
  },
  {
    slug: 'youxi',
    name: '游戏',
    icon: 'ri-gamepad-line',
    description: '游戏实况、攻略解说、电竞赛事，游戏玩家的聚集地',
    imageQuery: 'Gaming%20setup%20with%20mechanical%20keyboard%20and%20RGB%20mouse%2C%20gaming%20headset%20on%20dark%20desk%2C%20controller%20nearby%2C%20monitor%20glowing%20with%20warm%20amber%20light%2C%20modern%20minimalist%20gaming%20room%2C%20atmospheric%20mood%2C%20clean%20composition',
  },
  {
    slug: 'keji',
    name: '科技',
    icon: 'ri-cpu-line',
    description: '数码评测、科技资讯、前沿发明，走在科技最前沿',
    imageQuery: 'Modern%20tech%20workspace%20with%20laptop%20and%20smartphone%20on%20clean%20white%20desk%2C%20circuit%20board%20as%20decorative%20element%2C%20minimal%20tech%20gadgets%2C%20warm%20natural%20side%20lighting%2C%20professional%20product%20photography%2C%20neutral%20warm%20tones',
  },
];

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  imageQuery: string;
}